export default "//static.tradera.net/touchweb/static/output/images/app-download-desktop-2x.f1e7ca8f.png";